














































































































































import Vue from "vue";
import moment from "moment";

// Vue components
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";
import DeviceModelChip from "@/views/App/Components/chips/DeviceModelChip.vue";
import BranchFilter from "@/components/TableHeaderFilters/BranchFilter.vue";
import TagsFilter from "@/components/TableHeaderFilters/TagsFilter.vue";
import DateRangeFilter from "@/components/TableHeaderFilters/DateRangeFilter.vue";
import MachineModelFilter from "@/components/TableHeaderFilters/MachineModelFilter.vue";
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";
import InstallationFilter from "@/components/TableHeaderFilters/InstallationFilter.vue";
import CaosUserSyncRoleFilter from "@/components/TableHeaderFilters/CaosUserSyncRoleFilter.vue";
import EditCaosUserSyncConfigurationDialog from "./EditCaosUserSyncConfigurationDialog.vue";
import DeleteCaosUserSyncDialog from "./DeleteCaosUserSyncDialog.vue";

// Utility
import { dataTableItemsPerPage } from "@/utility/Constants";
import { mapGetters } from "vuex";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { DeleteCaosUserSyncConfigurationCommand } from "@/model/communication/caosConfiguration/DeleteCaosUserSyncConfigurationCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

export default Vue.extend({
    props: {
        loading: { required: true, type: Boolean },
        paginatedTotalItems: Number,
        installations: { required: true, type: Array },
        reqData: Object,
    },
    components: {
        TableFiltersRow,
        DeviceModelChip,
        ColumnVisibilityFilter,
        InstallationFilter,
        EditCaosUserSyncConfigurationDialog,
        DeleteCaosUserSyncDialog,
    },
    data() {
        return {
            moment,
            prevIcon: "fas fa-chevron-left",
            nextIcon: "fas fa-chevron-right",
            dataTableItemsPerPage,
            options: {},
            ignoreOptionsChanges: false,
            selectedDevices: [],
            availableHeaders: [
                { enabled: true, text: this.$t("common.name"), value: "name" },
                { enabled: false, text: this.$t("common.branch"), value: "branch.name", sortable: true },
                { enabled: false, text: this.$t("common.tags"), value: "tags", sortable: false },
                { enabled: false, text: this.$t("common.last_update"), value: "lastMessage" },
                { enabled: false, text: this.$t("common.agent_ip"), value: "agentInfo.ip" },
                { enabled: false, text: this.$t("device_status.agent_remote_ip"), value: "agentInfo.remoteIp", sortable: false },
                { enabled: false, text: this.$t("common.last_agent_message"), value: "agentInfo.lastMessage", sortable: true },
                { enabled: true, text: this.$t("common.device/s"), value: "machines", sortable: false },
                { enabled: true, text: this.$t("caos_user_sync.synchRole"), value: "isMaster", sortable: false },
                { enabled: true, text: this.$t("caos_user_sync.synchWith"), value: "syncToInstallationName", sortable: false },
                { enabled: true, text: this.$t("caos_user_sync.lastSynch"), value: "lastSynchronization", sortable: false },
                { enabled: true, text: this.$t("caos_user_sync.syncAt"), value: "syncTime", sortable: false },
            ],
            filters: [
                {
                    headerValue: "branch.name",
                    filterKey: "branchNames",
                    component: BranchFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "tags",
                    filterKey: "tagValues",
                    component: TagsFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "lastMessage",
                    filterKey: "installationLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_installation_message") }),
                },
                {
                    headerValue: "agentInfo.lastMessage",
                    filterKey: "agentLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_agent_message") }),
                },
                {
                    headerValue: "machines",
                    filterKey: "machineModels",
                    component: MachineModelFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "syncToInstallationName",
                    filterKey: "syncToInstallationName",
                    component: InstallationFilter,
                    currentSelections: "",
                },
                {
                    headerValue: "isMaster",
                    filterKey: "syncRole",
                    component: CaosUserSyncRoleFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "lastSynchronization",
                    filterKey: "lastSynchronizationDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_agent_message") }),
                },
            ],
            showEditCaosConfigurationDialog: false,
            editConfigInstallations: null,
            firstTime: true,
            showDeleteDialog: false,
            deleteLoading: false,
        };
    },
    computed: {
        ...mapGetters(["userTimeFormat"]),
    },
    watch: {
        options: {
            handler(newOptions, oldOptions) {
                if (oldOptions != null) {
                    if (newOptions.page < oldOptions.page) this.prevIcon = "fas fa-circle-notch fa-spin";
                    if (newOptions.page > oldOptions.page) this.nextIcon = "fas fa-circle-notch fa-spin";
                }
                if (!this.ignoreOptionsChanges) this.$emit("options-changed", newOptions);
                else this.ignoreOptionsChanges = false;
            },
            deep: true,
        },
        loading(newVal) {
            if (!newVal) {
                this.prevIcon = "fas fa-chevron-left";
                this.nextIcon = "fas fa-chevron-right";
            }
        },
    },
    methods: {
        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
                console.debug("backToTheFirst, this.options: ", this.options);
            }
        },
        openEditCaosUserSyncConfigurationDialog() {
            this.showEditCaosConfigurationDialog = true;
            this.editConfigInstallations = this.selectedDevices;
        },
        async deleteConfiguration() {
            this.deleteLoading = true;
            try {
                let response: ApiGenericResponse = await new DeleteCaosUserSyncConfigurationCommand(this.selectedDevices.map((i) => i.name)).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.showDeleteDialog = false;
                    this.$emit("reload");
                }
            } catch (e) {
                console.log("Something went wrong sending DeleteCaosUserSyncConfigurationCommand request ", e);
            }
            this.deleteLoading = false;
        },
    },
});
